import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import defaultObjEquals from '_legacy/components/grid/columnDefaults/defaultObjEquals';
import DateComparator from '_legacy/components/grid/comparators/DateComparator';
import DateEditor from '_legacy/components/grid/editors/DateEditor';
import DateFormatter from '_legacy/components/grid/formatters/DateFormatter';

export const createdDateHeading = {
    colId: 'createdDateTime',
    headerName: 'Created Date',
    field: 'createdDateTime',
    valueFormatter: DateFormatter,
    cellEditorFramework: DateEditor,
    editable: false,
    equals: defaultObjEquals,
    comparator: DateComparator,
    type: ['privatable'],
    excelExportFormat: 'date',
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filter: 'dateFilter',
};
